// extracted by mini-css-extract-plugin
export var audioPlayer = "_t7-0";